import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` no navegador, `useEffect` no pré-render.
 *
 * ## Por que não usar `useLayoutEffect` direto
 * Ele não roda no servidor — não existe layout para medir antes de pintar
 * quando ninguém vai pintar. O React sabe disso e AVISA no console a cada
 * render de pré-render: "useLayoutEffect does nothing on the server". O aviso
 * está certo, e silenciá-lo com um comentário seria esconder o sintoma; o
 * certo é pedir o efeito que aquele ambiente sabe cumprir.
 *
 * ## Por que a troca é segura aqui
 * Nenhum dos dois roda durante o pré-render — `useEffect` também não. A
 * escolha só decide QUAL função o React registra, e no Node nenhuma é
 * chamada. No navegador continua sendo `useLayoutEffect`, que é o que importa
 * para quem mede antes da pintura (a barra do seletor de planos apareceria na
 * posição errada por um quadro com `useEffect`).
 */
export const useEfeitoDeLayout =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
